define([
    "dojo/_base/declare",
    "csi/reflection",
    "csi/table/NewFrom"
], function(declare,reflection,NewFrom) {

return declare(NewFrom,
    {
        preProcess: function() {
            // summary: set the viewRef to the view of nodes of appropriate subclass of the StructureItem
            var cache = this.getCache();
            var node = cache.getNode(this.m_urlParent,true);
            var relation = reflection.getRelation(node, this.m_relation.m_id);
            var structureItemSubclass = relation.getDestinationClass().m_type;
            var defView = this.m_action.m_viewRef;
            defView.m_id = structureItemSubclass + "s";
            this.inherited(arguments);
        }

    });
});